import { ExternalLink } from '@localstack/constants';
import { Box, Link, styled } from '@mui/material';
import { ReactElement } from 'react';

import { FeedbackMessageBox } from '~/views/customer/Integrations/Github/components/FeedbackMessage';

const FAILED_STUDENT_VERIFICATION_ERROR_MESSAGE = (
  <>
    Unfortunately, we are unable to verify your status as a participant in the GitHub Student Developer Pack. Visit{' '}
    <Link href={ExternalLink.LOCALSTACK_FOR_STUDENTS} target="_blank" rel="noopener">
      GitHub Student Pack Home
    </Link>{' '}
    for additional information, or continue creating a free account.
  </>
);

const SpacingBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const SignUpStudentVerificationFailedErrorBox = (): ReactElement => (
  <SpacingBox>
    <FeedbackMessageBox severity="failure" message={FAILED_STUDENT_VERIFICATION_ERROR_MESSAGE} />
  </SpacingBox>
);
